import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import { useAuthStore } from '@/stores/authStore';
import { ANALYTICS_URL } from '@/config';

const Analytics = () => {
  const { i18n } = useTranslation();
  const token = useAuthStore((state) => state.token);

  const iframeSrc = useMemo(() => {
    // Build URL manually — URLSearchParams encodes "|" in token which breaks auth
    return `${ANALYTICS_URL}/?token=${token || ''}&&embedr&embed=true&tab=overview&lang=${i18n.language}`;
  }, [token, i18n.language]);

  if (!token) {
    return (
      <div className='w-full h-[calc(100vh-120px)] flex items-center justify-center'>
        <Spin size='large' />
      </div>
    );
  }

  return (
    <iframe
      src={iframeSrc}
      className='w-full h-[calc(100vh-120px)] border-0 rounded-lg overflow-hidden'
      title='Analytics'
      allow='clipboard-write'
    />
  );
};

export default Analytics;
